export default "__VITE_ASSET__y$wm0zEX__"